module.exports = __webpack_public_path__ + "static/media/icone_home.82d5b9a3.svg";